import Nullstack from 'nullstack';
export default function IconCompassOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-compass-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12.999 9l3.001 -1l-1.002 3.005m-.998 2.995l-6 2l2 -6"
  }), "   ", Nullstack.element("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v2"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h2"
  }), "   ", Nullstack.element("path", {
    d: "M19 12h2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}